import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { ICompanyTeamMember } from '@/types/companyTeamMember/models'
import { Person } from '~/cynqueModules/dataObjects/Person'
import { TeamMember } from '~/cynqueModules/dataObjects/TeamMember'

const apiEntityPath = '/api/companyteammembers'

export async function getCompanyTeamMembers({ apiPath = apiEntityPath } = {}) {
  const callingMn = getCompanyTeamMembers.name
  const companyTeamMembers = await httpGet<ICompanyTeamMember[]>({
    callingMn,
    apiPath,
  })
  return setUpCompanyTeamMembers(companyTeamMembers)
}

export async function createCompanyTeamMember(entity: ICompanyTeamMember) {
  const callingMn = createCompanyTeamMember.name
  const apiPath = apiEntityPath
  return httpPost<ICompanyTeamMember>({ callingMn, apiPath, entity })
}

export async function updateCompanyTeamMember(
  entityData: Partial<ICompanyTeamMember>,
  id: TEntityId
) {
  const callingMn = updateCompanyTeamMember.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialICompanyTeamMember = Partial<ICompanyTeamMember>
  return httpPatchMerge<TPartialICompanyTeamMember>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteCompanyTeamMember(entityData: ICompanyTeamMember) {
  const callingMn = deleteCompanyTeamMember.name
  const apiPath = apiEntityPath
  return httpDelete<ICompanyTeamMember>({
    callingMn,
    apiPath,
    entityData,
  })
}

export function setUpCompanyTeamMembers(
  companyTeamMembers: ICompanyTeamMember[]
) {
  companyTeamMembers.forEach((companyTeamMember) => {
    setUpCompanyTeamMember(companyTeamMember)
  })
  return companyTeamMembers
}

export function setUpCompanyTeamMember(companyTeamMember: ICompanyTeamMember) {
  companyTeamMember.teamMember = TeamMember(companyTeamMember.teamMember)
  return companyTeamMember
}
